import React, { Component } from 'react';

import Modal from 'react-bootstrap/Modal';
import PropTypes from 'prop-types';

export default class KuposModal extends Component {
	// constructor(props) {
	// 	super(props);
	// 	this.state = {
	// 		showModal: false, // Initially hide modal
	// 	};
	// }
	static propTypes = {
		showModal: PropTypes.bool,
		backdrop: PropTypes.bool,
		onHide: PropTypes.func,
		size: PropTypes.string,
		ariaLabel: PropTypes.string,

	};

	// componentDidMount() {
	// 	// Set timeout to show modal after 1000ms (1 second)
	// 	setTimeout(() => {
	// 		this.setState({ showModal: true });
	// 	}, 30000); // Adjust delay time as needed
	// }
	render() {
		return (
			<div className="common-kupos-modal">
				<Modal
					backdrop={this.props.backdrop}
					//show={this.state.showModal}
					show={this.props.showModal}
					onHide={this.props.onHide}
					size={this.props.size || 'md'}
					aria-labelledby={'contained-modal-title-vcenter ' + this.props.ariaLabel}
					centered
					className={`
            ${this.props.noPadding ? 'no-padding' : ' '}  ${this.props.noBackground ? 'no-background' : ''
						}`}
				>
					<Modal.Body>{this.props.children}</Modal.Body>
				</Modal>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/features/common/KuposModal.js